<template>
	<div class="accordion-item" :class="{ error }">
		<div class="header" @click="onClick">
			<div class="icon">
				<IconClose v-if="open" />
				<IconOpen v-else />
			</div>
			<p class="label">{{ label }}</p>
		</div>
		<div class="content" :style="expanded">
			<div class="inner">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
import IconOpen from 'mdi-vue/Plus'
import IconClose from 'mdi-vue/Minus'

export default {
	name: 'AccordionItem',
	props: {
		label: String,
		error: Boolean,
	},
	data() {
		return {
			open: false,
		}
	},
	computed: {
		expanded() {
			return {
				height: this.open ? 'auto' : '0px',
			}
		},
	},
	methods: {
		onClick() {
			this.$emit('open', !this.open)
		},
	},
	created() {
		this.$accordionItem = true
	},
	components: {
		IconOpen,
		IconClose,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.accordion-item {
	.header {
		@extend %flex-row;
		height: 3rem;
		background-color: $col-primary;
		border-bottom: 1px solid $white;
		cursor: pointer;

		.label {
			@extend %field-label;
			user-select: none;
			color: $white;
		}
		.icon {
			height: 1.5rem;
			margin: 0 0.5rem;
			color: $white;
		}
	}
	.content {
		overflow: hidden;
	}
	.inner {
		@include truncate-margin;
		padding: 1rem 0;
	}

	&.error .header {
		background-color: $col-error;
		.icon {
			color: $black;
		}
	}
}
</style>
